import { init, replayIntegration, rewriteFramesIntegration } from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

const initSentry = () => {
    let environment = window.location.hostname.split('.')[0];
    let dsn = 'https://531d3e5283ca3deaddc626317f9e4761@o4506977812938752.ingest.us.sentry.io/4508293287772162';
    let release = '{{SENTRY_RELEASE}}';
    let replaysSessionSampleRate = 0;

    if(window.location.href.includes('?sentry=debug')) {
        environment = 'debug';
        replaysSessionSampleRate = 1.0;
    }

    switch (environment) {
        case 'prodcm':
        case 'www':
        case 'stagingenv':
        case 'debug':
            dsn = dsn;
            break;
        default:
            dsn = '';
    }

    /*
    * ignoreErrors list was provided by Sentry
    * https://docs.sentry.io/clients/javascript/tips/
    * https://docs.sentry.io/platforms/javascript/session-replay/configuration/?original_referrer=https%3A%2F%2Fwww.google.com%2F
     */
    init({
        dsn: dsn,
        environment: environment,
        integrations: [
            new Integrations.BrowserTracing(),
            rewriteFramesIntegration({
                prefix: `${window.location.protocol}//${window.location.host}/public/js`
            }),
            replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                networkDetailAllowUrls: [/(https?:\/\/(.+?\.)?coveo\.com(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/]
            })
        ],
        release: release,
        allowUrls: [/(https?:\/\/(.+?\.)?coveo\.com(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/],
        replaysSessionSampleRate: replaysSessionSampleRate,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event, hint) {
            const error = JSON.stringify(hint.originalException?.stack);

            if(error && error.includes('coveo.com/public/js')) {
                return event;
            }

            return null;
        },
        ignoreErrors: [
            // Random plugins/extensions
            'top.GLOBALS',
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            'originalCreateNotification',
            'canvas.contentDocument',
            'MyApp_RemoveAllHighlights',
            'http://tt.epicplay.com',
            'Can\'t find variable: ZiteReader',
            'jigsaw is not defined',
            'ComboSearch is not defined',
            'http://loading.retry.widdit.com/',
            'atomicFindClose',
            // Facebook borked
            'fb_xd_fragment',
            // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this.
            // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
            'bmi_SafeAddOnload',
            'EBCallBackMessageReceived',
            // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
            'conduitPage',
            'fbq is not defined',
            `Cannot read property '1' of null`
        ],
        ignoreUrls: [
            // Facebook flakiness
            /graph\.facebook\.com/i,
            // Facebook blocked
            /connect\.facebook\.net\/en_US\/all\.js/i,
            // Woopra flakiness
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // Other plugins
            /127\.0\.0\.1:4001\/isrunning/i,
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
            // Firefox extensions
            /^resource:\/\//i,
            // Ignore Google flakiness
            /(?:analytics|g(?:tm|a))\.js/,
            'search.vibescaster.com',
            'fast.wistia.net',
            'scout.salesloft.com',
            'api.ipify.org'
        ]
    });
};

export default initSentry;